var _style, _linearGradient, _circle, _circle2, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "sup_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 127.84 127.84",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".sup_svg__st3{fill:#414141}")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "sup_svg__SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.822,
    y1: 109.021,
    x2: 109.021,
    y2: 18.822
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec008c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483,
    stopColor: "#f7941d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#ec008c"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.92,
    cy: 63.92,
    fill: "url(#sup_svg__SVGID_1_)",
    r: 63.78
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.92,
    cy: 63.92,
    r: 44.4,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.92 108.32c-11.19 0-21.88-4.18-30.11-11.78l3.42-3.7a39.245 39.245 0 0026.69 10.44c21.7 0 39.36-17.66 39.36-39.36S85.63 24.56 63.92 24.56v-5.04c24.48 0 44.4 19.92 44.4 44.4s-19.92 44.4-44.4 44.4z",
    fill: "#cf2437"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "sup_svg__st3",
    d: "M52.9 60.26l-3.5-2.85 1.43-1.75c1.13-1.38.8-2.41-.34-4.78-.99-2.05-2.64-5.47.58-8.39l1.67-1.52 3.03 3.35-1.67 1.52c-.55.5-.71.65.46 3.08 1.13 2.33 2.82 5.86-.22 9.6l-1.44 1.74zM73.54 60.26l-3.5-2.85 1.43-1.75c1.13-1.38.8-2.41-.34-4.78-.99-2.05-2.64-5.47.58-8.39l1.67-1.52 3.03 3.35-1.67 1.52c-.55.5-.71.65.46 3.08 1.13 2.33 2.82 5.86-.22 9.6l-1.44 1.74z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "sup_svg__st3",
    d: "M37.19 65.07c2.06 12.36 12.79 21.78 25.73 21.78s23.68-9.42 25.73-21.78H37.19z"
  })))));
}

export default SvgSup;